import { render, staticRenderFns } from "./AnimationComposer.vue?vue&type=template&id=4e92af84&"
import script from "./AnimationComposer.vue?vue&type=script&lang=js&"
export * from "./AnimationComposer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports